import _pt from "prop-types";
import * as React from 'react';
import { usePkpass } from '../../../usePkpass';
import { PkpassPassStyleTypes } from '../../../../../../types';
import { getValueValue } from './FieldPreviewValue';
import { getLabelValue } from './FieldPreviewLabel';
import { useTheme } from '../../../../Theme';
export const FieldPreviewPrimary = props => {
  const {
    pass,
    language,
    passStyle
  } = usePkpass();
  const theme = useTheme();
  const {
    values
  } = props;

  if (passStyle === PkpassPassStyleTypes.EventTicket) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: theme.scale * 290,
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 40,
        height: theme.scale * 50,
        lineHeight: `${theme.scale * 40}px`,
        marginTop: theme.scale * 20,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, getValueValue(values, language)));
  }

  if (passStyle === PkpassPassStyleTypes.StoreCard || passStyle === PkpassPassStyleTypes.Coupon) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: theme.scale * 290
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 38,
        height: theme.scale * 40,
        lineHeight: `${theme.scale * 38}px`,
        marginTop: theme.scale * 30,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, getValueValue(values, language) || /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 15,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, getLabelValue(values, language)));
  }

  if (passStyle === PkpassPassStyleTypes.BoardingPass) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.labelColor,
        fontSize: theme.scale * 10,
        height: `${theme.scale * 1.3}em`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, getLabelValue(values, language)), /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        fontSize: theme.scale * 30,
        height: theme.scale * 34,
        lineHeight: `${theme.scale * 30}px`,
        marginTop: theme.scale * 10,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, getValueValue(values, language)));
  }

  if (passStyle === PkpassPassStyleTypes.Generic) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: 200
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.labelColor,
        fontSize: 10,
        height: '1.3em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, getLabelValue(values, language)), /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        fontSize: 30,
        height: 34,
        lineHeight: '30px',
        marginTop: 10,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, getValueValue(values, language)));
  }

  return null;
};
//# sourceMappingURL=FieldPreviewPrimary.js.map